module.exports = __webpack_public_path__ + "img/20190905155338154.70842395.jpg";